<template>
  <section class="content" style="padding-left: 0px;padding-right: 0px;">
    <div class="row">
      <div class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8">
        <router-link to="/products-view"><p class="sg-top"><i class="fa fa-chevron-left" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;{{this.$store.state.viewVideoName}}</p></router-link>
    </div>
    </div>
    <div>
        <div class="embed-responsive embed-responsive-16by9" id="parent">
          <iframe class="embed-responsive-item" id="player1" src="" :src='catalogueUrl' allow="autoplay; fullscreen" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
<!--          <iframe class="embed-responsive-item" id="player1" :src="getDataVideo.url + '?title=false&autoplay=true'" allow="autoplay; fullscreen" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>-->
        </div>
      <p class="sg-pname">{{this.$store.state.viewVideoName}}</p>
    <p class="sg-disco">{{this.$store.state.viewVideoDescription}}</p>
    </div>
  </section>
</template>
<script>
  export default {
    name: 'productCatalogue2',
    data: () => ({
      catalogueUrl: ''
    }),
    created() {
      this.catalogueUrl = this.$store.state.viewVideoUrl
    },
    methods: {
    }
  }
</script>



// WEBPACK FOOTER //
// SingleProductVideo.vue?36ac6038